import React from "react";
import { Pulse } from "@phosphor-icons/react";

/**
 * Tiny live-signal pill shown on solution cards.
 * Pulsing dot + icon + label — used to hint at AI-powered or real-time features.
 */
export default function LiveSignalPill({ label, tone = "signal", className = "", testId }) {
  const tones = {
    signal: "bg-[hsl(var(--appistry-signal)/0.08)] text-[hsl(var(--appistry-signal))] border-[hsl(var(--appistry-signal)/0.25)]",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    rose: "bg-rose-50 text-rose-700 border-rose-200",
  };
  const dotTones = {
    signal: "bg-[hsl(var(--appistry-signal))]",
    emerald: "bg-emerald-500",
    rose: "bg-rose-500",
  };
  return (
    <span
      className={`inline-flex items-center gap-1.5 border px-2 py-0.5 text-[10px] font-mono uppercase tracking-[2px] font-bold ${tones[tone]} ${className}`}
      data-testid={testId}
    >
      <span className="relative flex h-1.5 w-1.5">
        <span className={`absolute inline-flex h-full w-full animate-ping rounded-full opacity-75 ${dotTones[tone]}`} />
        <span className={`relative inline-flex h-1.5 w-1.5 rounded-full ${dotTones[tone]}`} />
      </span>
      <Pulse size={11} weight="bold" />
      {label}
    </span>
  );
}
